import { render, staticRenderFns } from "./ProjectList2.vue?vue&type=template&id=ff4dd85c&scoped=true&lang=pug&"
import script from "./ProjectList2.vue?vue&type=script&lang=js&"
export * from "./ProjectList2.vue?vue&type=script&lang=js&"
import style0 from "./ProjectList2.vue?vue&type=style&index=0&id=ff4dd85c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4dd85c",
  null
  
)

export default component.exports